import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import SuperButton from "../../elements/super-button";
import classNames from "classnames";
import Icon from "../../elements/icon";
import Heading from "../../elements/heading";
import Image from "../../elements/image";
import "./style.scss";

export default class IconContent extends Component {
  componentDidMount() {}

  iconContentContent(model) {
    const { paddingAboveTop, paddingAboveBottom, backgroundColor, backgroundImage, gridType, order, image, icons, overlineText, headingType, headingBody, body, bulletListItems, CTA, equalColumns } = model.fields;
    let top = paddingAboveTop?.fields.phrase.value ?? "default",
      bottom = paddingAboveBottom?.fields.phrase.value ?? "default";
    const iconContentClasses = classNames("icon-content", "padding-top-" + top, "padding-bottom-" + bottom, {
      reverse: (order && order.fields.phrase.value) === "reverse",
      "grid-story": (gridType && gridType.fields.phrase.value) === "story",
      "grid-mini": (gridType && gridType.fields.phrase.value) === "mini",
      grid: (gridType && gridType.fields.phrase.value) === "normal"
    });
    let noImage = image ? !Object.keys(image.value).length : true;
    const textSectionClasses = classNames("text-section", {
      "no-image": noImage,
      "one-third": !equalColumns.value
    });

    let backgroundStyle = {};
    if (backgroundColor) {
      backgroundStyle = {
        background: backgroundColor.fields.phrase.value
      };
    }

    if (backgroundImage && backgroundImage.value.src) {
      backgroundStyle = {
        backgroundImage: "url(" + backgroundImage.value.src + ")"
      };
    }

    const mediaContainerClasses = classNames("media-container", {
      "two-third": !equalColumns.value
    });

    return (
      <div className={iconContentClasses} style={backgroundStyle} datasourceid={this.props.rendering.dataSource}>
        <div className={textSectionClasses}>
          {icons && icons.value && (
            <div className={"top-icon-container"}>
              <Icon icon={{ ...icons.value }} />
            </div>
          )}

          {overlineText && overlineText.value != null && <span className="overline">{overlineText.value}</span>}

          <Heading
            {...{
              type: headingType,
              html: headingBody
            }}
            className={"title"}
          />

          {body.value && (
            <div className={"body-text"}>
              <RichText field={body} tag={"p"} />
            </div>
          )}
          {bulletListItems && bulletListItems.length !== 0 && (
            <div className={"body-text"}>
              <ul>
                {bulletListItems.map((item, index) => {
                  return (
                    <li key={index}>
                      {item.fields.iconName && item.fields.iconName.value && item.fields.iconName.value.alt && <RichText field={{ value: item.fields.iconName.value.alt }} />}
                      {item.fields.body && item.fields.body.value}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          {CTA && CTA.length !== 0 && <div className={"button-container"}>{CTA && CTA.map((item, index) => item.fields && item.fields.ctatype && item.fields.ctatype.fields && <SuperButton key={index} {...item.fields} />)}</div>}
        </div>

        {image && image.value && image.value.src != null && (
          <div className={mediaContainerClasses}>
            <Image {...model.fields.image.value} />
          </div>
        )}
      </div>
    );
  }

  render() {
    if (!this.props.fields) return null;
    let model = this.props,
      gridType = model.fields.gridType?.fields.phrase.value;

    if (gridType === "story") {
      return <div className={"grid"}>{this.iconContentContent(model)}</div>;
    } else if (gridType === "mini") {
      return (
        <div className="grid">
          <div className="grid-mini">
            <div className="mini-content">{this.iconContentContent(model)}</div>
          </div>
        </div>
      );
    } else {
      return this.iconContentContent(model);
    }
  }
}
